import React, { Component } from 'react';
import { connect } from 'react-redux';
import Fire, { firebaseAuth } from '../../../config/Fire';
import store from '../../../config/Store';
import { Loading, H1 } from './../../common';
import { MatchSquadPlayerUser, MatchSquadManagerUser } from './../../layouts';
import { matchFetch, singleMatchFetch } from './../../../actions/MatchActions';
import { signInAnonymously } from './../../../actions/AuthActions';
import ToggleButton from 'react-toggle-button';
import {
	addPlayerRatingByMatch,
	getPlayerRatingByUser,
	fetchMatchByUser,
	fetchPlayerRatingsByUser,
	updateReveal,
} from './../../../actions/UserRatingActions';
import { matchSquadFetch, onAvgRatingChange } from './../../../actions/MatchSquadActions';
import { playerFetch } from './../../../actions/PlayerActions';
import './UserRating.css';

class UserRating extends Component {
	constructor(props) {
		super(props);
		this.state = {
			postId: '',
			season: {
				0: { name: '2018-19', id: 0 },
				1: { name: '2019-20', id: 1 },
				2: { name: '2020-21', id: 2 },
				3: { name: '2021-22', id: 3 },
			},
			seasonById: [0, 1, 2, 3],
			season_id: 3,
			name: '',
			modal: false,
			toDelete: '',
			toDeleteId: null,
			goals: {
				0: {
					name: 0,
					id: 0,
				},
				1: {
					name: 1,
					id: 1,
				},
				2: {
					name: 2,
					id: 2,
				},
				3: {
					name: 3,
					id: 3,
				},
				4: {
					name: 4,
					id: 4,
				},
				5: {
					name: 5,
					id: 5,
				},
			},
			goalsById: [0, 1, 2, 3, 4, 5],
			cards: {
				0: {
					name: 'None',
					id: 0,
				},
				1: {
					name: 'Yellow',
					id: 1,
				},
				2: {
					id: 2,
					name: '2 Yellow',
				},
				3: {
					id: 3,
					name: 'Red',
				},
			},
			cardsById: [0, 1, 2, 3],
			formation: {
				1: {
					name: '442',
					id: 1,
					positions: [
						'gk',
						'divider',
						'rb',
						'rcb',
						'lcb',
						'lb',
						'divider',
						'rm',
						'rcm',
						'lcm',
						'lm',
						'divider',
						'rst',
						'lst',
						'divider',
						'sub1',
						'sub2',
						'sub3',
						'sub4',
						'sub5',
						'sub6',
						'sub7',
						'Manager',
					],
				},
				2: {
					name: '352',
					id: 2,
					positions: [
						'gk',
						'divider',
						'cb1',
						'cb2',
						'cb3',
						'divider',
						'rwb',
						'rcm',
						'lcm',
						'lwb',
						'ram',
						'acm',
						'lam',
						'divider',
						'st',
						'divider',
						'sub1',
						'sub2',
						'sub3',
						'sub4',
						'sub5',
						'sub6',
						'sub7',
						'Manager',
					],
				},
				3: {
					name: '433',
					id: 3,
					positions: [
						'gk',
						'divider',
						'rb',
						'rcb',
						'lcb',
						'lb',
						'divider',
						'rdm',
						'dm',
						'ldm',
						'rcm',
						'lcm',
						'acm',
						'divider',
						'ram',
						'lam',
						'st',
						'divider',
						'sub1',
						'sub2',
						'sub3',
						'sub4',
						'sub5',
						'sub6',
						'sub7',
						'Manager',
					],
				},
			},
			formationById: [1, 2, 3],
			formationIndex: 0,
		};
		this.handleUserRatingChange = this.handleUserRatingChange.bind(this);
		this.handleUserRevealChange = this.handleUserRevealChange.bind(this);

		this.refUserRating = Fire.firestore().collection('userRatingByUsers');
		this.unsubscribeRefUserRating = null;
		this.refMatchSquad = Fire.firestore().collection('matchSquads');
		this.unsubscribeRefMatchSquad = null;
	}
	componentWillMount() {
		this.props._playerFetch();
		if (typeof this.props.match.params.season === 'undefined') {
			this.props._matchFetch(this.state.season[0].name);
		}
		if (typeof this.props.match.params.season !== 'undefined') {
			this.props._singleMatchFetch(
				this.state.season[this.props.match.params.season].name,
				this.props.match.params.number,
			);
		}
	}
	componentDidMount() {
		firebaseAuth().onAuthStateChanged(user => {
			if (user) {
				this.setState({
					uid: user.uid,
				});
				this.props._fetchPlayerRatingsByUser(user.uid, this.props.match.params.number.toString());
				this.props._fetchMatchByUser(user.uid, this.props.match.params.number.toString());
				return (this.unsubscribeRefUserRating = this.refUserRating
					.doc(user.uid)
					.collection('matches')
					.doc(this.props.match.params.number.toString())
					.collection('players')
					.onSnapshot(
						snap => {
							snap.docChanges().forEach(change => {
								if (typeof change.doc !== 'undefined') {
									if (change.type === 'added' || change.type === 'modified') {
										this.props._getPlayerRatingByUser(
											change.doc.data(),
											change.doc.id,
											this.props.match.params.number.toString(),
										);
									}
								}
							});
						},
						function(_e) {
							console.log('_e', _e);
						},
					));
			}
			this.props._signInAnonymously();
		});
		this.props._matchSquadFetch(this.props.match.params.number);

		this.unsubscribeRefMatchSquad = this.refMatchSquad
			.doc(this.props.match.params.number.toString())
			.collection('squad')
			.onSnapshot(
				snap => {
					snap.docChanges().forEach(change => {
						if (typeof change.doc !== 'undefined') {
							if (change.type === 'added' || change.type === 'modified') {
								this.props._onAvgRatingChange(this.props.match.params.number, change.doc.data());
							}
						}
					});
				},
				function(_e) {
					console.log('_e', _e);
				},
			);
	}

	componentWillUnmount() {
		this.unsubscribeRefUserRating();
		this.unsubscribeRefMatchSquad();
	}

	handleUserRevealChange = val => {
		console.log(val);
	};

	handleUserRatingChange = (val, obj) => {
		this.props._addPlayerRatingByMatch(
			parseInt(this.props.match.params.number, 10),
			obj,
			val,
			this.state.uid,
		);
	};

	_loading() {
		if (this.props.loading) return <Loading />;
		return null;
	}
	_parseGoals = goal => {
		if (typeof goal === 'undefined') return <span />;
		if (goal === 0) return <span />;
		let gs = [];
		for (let r = 0, lenR = goal; r < goal; r++) {
			gs.push(<span key={r}>⚽</span>);
		}
		return <div>{gs}</div>;
	};
	_parseGoalValue = goal => goal;
	_parseCards = cards => {
		if (typeof cards === 'undefined') return null;
		if (cards === 'None') return null;
		if (cards === 'Yellow') return <i className="fa fa-circle yellow" />;
		if (cards === '2 Yellow')
			return (
				<div className="card-meta">
					<i className="fa fa-circle yellow first" />
					<i className="fa fa-circle yellow second" />
					<i className="fa fa-circle warningred third" />
				</div>
			);
		if (cards === 'Red') return <i className="fa fa-circle warningred" />;
	};
	_parseCardValue = cards => {
		if (cards === 'None') return 0;
		if (cards === 'Yellow') return 1;
		if (cards === '2 Yellow') return 2;
		if (cards === 'Red') return 3;
	};

	_hasVoted = (list, player) => {
		if (typeof list === 'undefined') return {};
		if (typeof list[player.playerDoc] === 'undefined') return {};
		return list;
	};

	_reveal = list => {
		if (typeof list === 'undefined') return false;
		if (typeof list.reveal === 'undefined') return false;
		return list.reveal;
	};

	_renderList(arr) {
		let items = [];
		if (!this.props.squadList[parseInt(this.props.match.params.number, 10)]) {
			return <ul>{items}</ul>;
		}
		items = arr.map((v, i) => {
			if (v === 'divider') {
				return <li key={v + '_' + i} className="flexContainerRow section-divider" />;
			}
			if (!this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]) {
				return null;
			}
			if (
				!this.props.playerList[
					this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v].playerDoc
				]
			) {
				return null;
			}

			return (
				<li
					className="flexContainerRow matchDetail wrap"
					key={
						this.state.formation[
							this.props.list[parseInt(this.props.match.params.number, 10)].formation_id
						].name +
						'_' +
						v
					}>
					<div className="item">
						{this.props.playerList[
							this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v].onChange
								.playerDoc
						].type === 'Manager' ? (
							<MatchSquadManagerUser
								player={
									this.props.playerList[
										this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
											.playerDoc
									]
								}
								playerReport={
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
								}
								onTextChange={this.handleReviewChange}
								positions={this.state.formation[
									this.props.list[parseInt(this.props.match.params.number, 10)].formation_id
								].positions.filter(curr => curr !== 'divider')}
								reveal={this._reveal(
									this.props.voteList[parseInt(this.props.match.params.number, 10)],
								)}
								voteOpen={this.props.list[parseInt(this.props.match.params.number, 10)].voteOpen}
								onPositionChange={this.handlePositionChange}
								onRatingChange={this.handleRatingChange}
								onUserRatingChange={this.handleUserRatingChange}
								userRating={
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.userRating
								}
								hasVoted={this._hasVoted(
									this.props.voteList[parseInt(this.props.match.params.number, 10)],
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v],
								)}
							/>
						) : (
							<MatchSquadPlayerUser
								player={
									this.props.playerList[
										this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
											.playerDoc
									]
								}
								playerReport={
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
								}
								goals={this._parseGoals(
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.goals,
								)}
								goalValue={this._parseGoalValue(
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.goals,
								)}
								cards={this._parseCards(
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.cards,
								)}
								cardValue={this._parseCardValue(
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.cards,
								)}
								onTextChange={this.handleReviewChange}
								onGoalChange={this.handleGoalsChange}
								onCardChange={this.handleCardsChange}
								positions={this.state.formation[
									this.props.list[parseInt(this.props.match.params.number, 10)].formation_id
								].positions.filter(curr => curr !== 'divider')}
								reveal={this._reveal(
									this.props.voteList[parseInt(this.props.match.params.number, 10)],
								)}
								voteOpen={this.props.list[parseInt(this.props.match.params.number, 10)].voteOpen}
								onPositionChange={this.handlePositionChange}
								onRatingChange={this.handleRatingChange}
								onUserRatingChange={this.handleUserRatingChange}
								userRating={
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v]
										.onChange.userRating
								}
								hasVoted={this._hasVoted(
									this.props.voteList[parseInt(this.props.match.params.number, 10)],
									this.props.squadList[parseInt(this.props.match.params.number, 10)].squad[v],
								)}
							/>
						)}
					</div>
				</li>
			);
		});
		return <ul>{items}</ul>;
	}
	render() {
		if (this.props.loading) return <Loading />;
		if (this.props.squadLoading) return <Loading />;
		if (this.props.playerLoading) return <Loading />;
		if (!this.props.list) return <Loading />;

		if (!this.props.list[parseInt(this.props.match.params.number, 10)]) return <Loading />;
		return (
			<div>
				<div className="container">
					<div className="match userRating">
						<H1 text={this.props.list[parseInt(this.props.match.params.number, 10)].title} />
						<div className="gap flexContainerRow">
							<div className="smaller">Reveal Arseblog ratings?</div>
							<div className="bigger">
								<ToggleButton
									inactiveLabel={'No'}
									activeLabel={'Yes'}
									value={this._reveal(
										this.props.voteList[parseInt(this.props.match.params.number, 10)],
									)}
									onToggle={value => {
										this.props._updateReveal(
											!value,
											parseInt(this.props.match.params.number, 10),
											this.state.uid,
										);
									}}
								/>
							</div>
						</div>

						<div className="section flexContainerRow">
							<div className="item">
								{this._renderList(
									this.state.formation[
										this.props.list[parseInt(this.props.match.params.number, 10)].formation_id
									].positions,
								)}
							</div>
						</div>
						<div className="flexContainerRow">
							<div className="item white">
								<div className="bonusWrap grey1-border-shadow">
									<h3>Bonus rating</h3>
									{this.props.list[parseInt(this.props.match.params.number, 10)].bonus}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
const mapStateToProps = ({ match, matchSquad, player, userRating }) => {
	const { loading, errorText, list } = match;
	return {
		squadList: matchSquad.list,
		squadLoading: matchSquad.loading,
		squadErrorText: matchSquad.errorText,
		inputPlayer: matchSquad.inputPlayer,
		inputPosition: matchSquad.inputPosition,
		inputGoal: matchSquad.inputGoal,
		inputCard: matchSquad.inputCard,
		inputMatchRating: matchSquad.inputMatchRating,
		inputReview: matchSquad.inputReview,
		inputLoading: matchSquad.inputLoading,
		playerLoading: player.loading,
		playerList: player.list,
		playerListById: player.listByID,
		loading,
		errorText,
		list,
		voteList: userRating.list,
	};
};
const mapDispatchToProps = dispatch => ({
	_signInAnonymously: () => dispatch(signInAnonymously()),
	_singleMatchFetch: (season, match) => dispatch(singleMatchFetch(season, match)),
	_matchFetch: season => dispatch(matchFetch(season)),
	_playerFetch: () => dispatch(playerFetch()),
	_matchSquadFetch: id => dispatch(matchSquadFetch(id)),
	_addPlayerRatingByMatch: (matchDoc, obj, val, uid) =>
		dispatch(addPlayerRatingByMatch(matchDoc, obj, val, uid)),
	_fetchPlayerRatingsByUser: (uid, matchDoc) => dispatch(fetchPlayerRatingsByUser(uid, matchDoc)),
	_getPlayerRatingByUser: (obj, id, matchId) => dispatch(getPlayerRatingByUser(obj, id, matchId)),
	_fetchMatchByUser: (id, matchId) => dispatch(fetchMatchByUser(id, matchId)),
	_onAvgRatingChange: (i, obj) => dispatch(onAvgRatingChange(i, obj)),
	_updateReveal: (val, matchDoc, uid) => dispatch(updateReveal(val, matchDoc, uid)),
});
export default connect(mapStateToProps, mapDispatchToProps)(UserRating);



// WEBPACK FOOTER //
// ./src/components/screens/userRating/UserRating.js